const toNumber = (value) => {
    const number = Number(value);
    return isFinite(number) ? number : 0;
};

// 4.25 -> "4.3", 10 -> "10" (never "10.0")
const trimDecimal = (value) => {
    const rounded = Math.round(value * 10) / 10;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
};

export const formatCount = (value) => toNumber(value).toLocaleString('en-US');

const SCALES = [
    { limit: 1e12, short: 'T', long: 'Trillion' },
    { limit: 1e9,  short: 'B', long: 'Billion' },
    { limit: 1e6,  short: 'M', long: 'Million' },
    { limit: 1e3,  short: 'K', long: 'Thousand' }
];

// Pick the scale the number reads at *after* rounding to one decimal. Choosing
// on the raw value instead would render 999,999,999 as "1000M" rather than
// promoting it to "1B" - and likewise 999,999 as "1000K".
const scaleFor = (number) =>
    SCALES.find((scale) => Math.round((number / scale.limit) * 10) / 10 >= 1);

const scaled = (value, suffixFor) => {
    const number = toNumber(value);
    const scale = scaleFor(number);

    return scale ? `${trimDecimal(number / scale.limit)}${suffixFor(scale)}` : formatCount(number);
};

// Headline figure: 4200000000 -> "4.2 Billion"
export const formatStepsLong = (value) => scaled(value, (scale) => ` ${scale.long}`);

// Legend / caption figure: 4200000000 -> "4.2B", 10000000000 -> "10B"
export const formatStepsShort = (value) => scaled(value, (scale) => scale.short);

// "10:30 AM, Thu, 14 May 2026"
export const formatTimestamp = (date) => {
    const time = date.toLocaleTimeString('en-US', {
        hour: 'numeric', minute: '2-digit', hour12: true
    });
    const day = date.toLocaleDateString('en-GB', {
        weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'
    });
    return `${time}, ${day}`;
};

// Mix a hex colour into white. The CTA panel in every sample is a light wash of
// the header colour, so it is derived rather than stored.
export const tint = (hex, amount = 0.12) => {
    const match = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
    if (!match) return '#F5F5F7';

    const value = parseInt(match[1], 16);
    const channels = [(value >> 16) & 255, (value >> 8) & 255, value & 255]
        .map((channel) => Math.round(255 + (channel - 255) * amount));

    return `#${channels.map((c) => c.toString(16).padStart(2, '0')).join('')}`;
};
